import React, { useState } from "react";
// フォームコンポーネント
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Typography,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  IconButton,
  Container,
  Button,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "../modules/modules";
import SendIcon from "@material-ui/icons/Send";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
    height: "600px",
  },
  maxWidth: {
    width: "100%",
  },
  interval: {
    marginTop: theme.spacing(5),
  },
  button: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
}));

// 受注情報のヘッダー情報
const columns = [
  { id: "id", minWidth: 170, type: "text" },
  { id: "name", minWidth: 60, type: "text" },
  { id: "domain", minWidth: 60, type: "text" },
  { id: "spider", minWidth: 60, type: "text" },
  { id: "link", minWidth: 170, type: "text" },
];
// 新規登録のヘッダー情報
const newColumns = [
  { id: "name", minWidth: 60, type: "text" },
  { id: "domain", minWidth: 60, type: "text" },
  { id: "spider", minWidth: 60, type: "text" },
  { id: "link", minWidth: 170, type: "text" },
];

// ■■■■■■■■■■■■■■■■■■
// list
// ■■■■■■■■■■■■■■■■■■
export function Shop(props) {
  const classes = useStyles();
  const handleUpdateGraphql = props.handleUpdateGraphql;
  const allShops = props.allShops;

  return (
    <React.StrictMode>
      <TableContainer className={classes.table}>
        <Table stickyHeader>
          <TableHead>
            <StyledTableRow>
              {columns.map((column) => (
                <StyledTableCell key={column.id}>{column.id}</StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {allShops.map((item) => {
              return (
                <StyledTableRow key={item["id"]}>
                  {columns.map((col) => (
                    <>
                      <StyledTableCell
                        key={col.id}
                        style={{ minWidth: col.minWidth }}
                      >
                        <form
                          onSubmit={(values) => {
                            handleUpdateGraphql("updateShop", values);
                          }}
                        >
                          <TextField
                            name={item["id"]}
                            type={col["type"]}
                            label={col["id"]}
                            defaultValue={item[col["id"]]}
                          />
                          <IconButton color="secondary" type="submit">
                            <SendIcon />
                          </IconButton>
                        </form>
                      </StyledTableCell>
                    </>
                  ))}
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </React.StrictMode>
  );
}

// ■■■■■■■■■■■■■■■■■■
// list
// ■■■■■■■■■■■■■■■■■■
export function ShopCreate(props) {
  const classes = useStyles();
  const [submitMessage, setSubmitMessage] = useState({});

  const handleCreateGraphql = props.handleCreateGraphql;
  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      setSubmitMessage(values);
      handleCreateGraphql("createShop", values);
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("nameは必須です。"),
      domain: Yup.string().required("domainは必須です。"),
    }),
  });

  return (
    <React.StrictMode>
      <Container className={classes.interval}>
        <Typography variant="h4" align="center">
          新規登録
        </Typography>
        <form onSubmit={formik.handleSubmit}>
          {newColumns.map((column) => (
            <div key={column.id}>
              <TextField
                label={column.id}
                type={column.type}
                className={classes.maxWidth}
                {...formik.getFieldProps(column.id)}
              />
              {formik.touched[column.id] && formik.errors[column.id] ? (
                <Typography variant="caption" color="error">
                  {formik.errors[column.id]}
                </Typography>
              ) : null}
            </div>
          ))}
          <Button
            className={classes.button}
            variant="contained"
            type="submit"
            disabled={!formik.isValid}
          >
            登録
          </Button>
          {formik.isSubmitting ? (
            <Typography variant="caption" color="error">
              登録しました：{JSON.stringify(submitMessage)}
            </Typography>
          ) : null}
        </form>
      </Container>
    </React.StrictMode>
  );
}
